var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBancolombiaLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0806 11.0621C8.23032 11.6346 8.81437 11.9302 9.4077 11.736C14.2721 10.2617 19.1482 9.25292 24.1798 8.51904C24.7564 8.44305 25.072 7.85582 24.86 7.26675C24.4133 6.02572 24.1874 5.40674 23.7306 4.17247C23.5368 3.64853 23.0125 3.30484 22.4761 3.36219C17.559 3.95925 12.8084 4.84102 8.0474 6.19921C7.42726 6.39092 7.04676 7.07462 7.20309 7.68131C7.55079 9.03151 7.7263 9.70763 8.0806 11.0621Z",
    fill: "#2C2A29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5606 11.7859C27.373 11.2297 26.8642 10.8581 26.3609 10.9238C18.7158 11.8923 11.2713 13.771 4.21177 16.8761C3.69685 17.118 3.38798 17.7621 3.49613 18.3292C3.77264 19.7804 3.91232 20.5067 4.19477 21.9608C4.31562 22.5825 4.89977 22.8687 5.47593 22.5891C12.6463 19.3248 20.2241 17.2463 27.9977 16.007C28.4917 15.9267 28.7436 15.3639 28.5546 14.7839C28.1627 13.5819 27.9639 12.9821 27.5606 11.7859Z",
    fill: "#2C2A29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6141 19.9014C27.4256 19.3039 26.8743 18.9137 26.3507 19.0223C21.6008 20.0588 16.9578 21.3082 12.3585 22.8982C11.7752 23.1134 11.4467 23.7325 11.6001 24.3021C11.9655 25.6586 12.1496 26.3381 12.5199 27.6992C12.6938 28.3383 13.4069 28.6654 14.064 28.4135C18.6619 26.7574 23.3058 25.3111 28.0511 24.1516C28.5064 24.0401 28.7304 23.5032 28.561 22.9493C28.1876 21.7275 27.9981 21.118 27.6141 19.9014Z",
    fill: "#2C2A29"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBancolombiaLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BancolombiaLogo.15924370667e946f6fbf67def1cf341c.svg";